<script setup lang="ts">
import { translate } from '@/shared/i18n';
import { Btn } from '@/shared/ui';

const emit = defineEmits<{
  (e: 'click:delete:for-everyone'): void;
  (e: 'click:delete:for-me'): void;
  (e: 'click:cancel'): void;
}>();
</script>

<template>
  <div class="flex flex-col gap-2">
    <Btn
      type="danger"
      text
      outline
      @click="emit('click:delete:for-everyone')"
    >
      {{ translate('message.deleteForEveryone') }}
    </Btn>

    <Btn
      type="danger"
      text
      outline
      @click="emit('click:delete:for-me')"
    >
      {{ translate('message.deleteForMe') }}
    </Btn>

    <Btn
      text
      outline
      class="m1-2"
      @click="emit('click:cancel')"
    >
      {{ translate('common.cancel') }}
    </Btn>
  </div>
</template>
